import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { NavBar } from './NavBar';
import { TabBar } from './TabBar';

interface LayoutWrapperProps {
  children: React.ReactNode;
}

export function LayoutWrapper({ children }: LayoutWrapperProps) {
  const location = useLocation();
  const pathname = location.pathname;
  const { isAuthenticated } = useAuth();
  
  // Don't show NavBar/TabBar on auth page or landing page
  const showNavigation = isAuthenticated && pathname !== '/auth';

  return (
    <>
      {showNavigation && <NavBar />}
      <div
        style={{ 
          minHeight: showNavigation 
            ? 'calc(100vh - 56px - max(64px, calc(49px + env(safe-area-inset-bottom, 0px))))'
            : '100vh',
          paddingTop: showNavigation 
            ? 'calc(56px + env(safe-area-inset-top, 0px))'
            : 'env(safe-area-inset-top, 0px)',
          paddingBottom: showNavigation 
            ? 'max(64px, calc(49px + env(safe-area-inset-bottom, 0px)))'
            : 'env(safe-area-inset-bottom, 0px)'
        }}
      >
        {children}
      </div>
      {showNavigation && <TabBar />}
    </>
  );
}

